import { useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import type { EnvironmentLookupFn } from '../public-types';
import { useEnvironment } from '../environment';

function generateNewDataRefId() {
  return uuidv4();
}

export function useDataRefId(name?: string, environmentLookupFn?: EnvironmentLookupFn) {
  const environment = useEnvironment(environmentLookupFn);
  const dataRefIdRef = useRef<string | null>(null);

  if (!name && dataRefIdRef.current) {
    return dataRefIdRef.current;
  }
  if (environment) {
    if (name) {
      if (!environment.dataRefIdPool[name]) {
        environment.dataRefIdPool[name] = generateNewDataRefId();
      }
      dataRefIdRef.current = environment.dataRefIdPool[name];
    } else {
      dataRefIdRef.current = generateNewDataRefId();
    }
  }
  return dataRefIdRef.current;
}
